<template>
  <div>
    <cx-dialog v-if='showForm'
               :visible="showForm"
               :title='title'
               :model='form'
               width="60%"
               :top="'3vh'"
               @close='showForm = false'>
      <div style="margin-bottom:28px;margin-left:28px">
        <el-row>
          <el-col :span="6">
            服务单:{{selectedRows[0].id}}
          </el-col>
          <el-col :span="6">
            服务对象:{{selectedRows[0].emp_name}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            服务类型:{{selectedRows[0].type_name}}
          </el-col>
          <el-col :span="6">
            服务单状态:{{selectedRows[0].status_name}}
          </el-col>
        </el-row>
      </div>
      <div style="margin-bottom:28px;margin-left:28px">
        <el-row>
          <el-col :span="6">
            <h4>历史记录</h4>
          </el-col>
        </el-row>
        <el-table v-loading="formLoading" :data="formData"
                border
                highlight-page-row
                size='mini'
                style="width:100%;">
          <el-table-column prop="create_time" label="提交时间" width="200"></el-table-column>
          <el-table-column prop="status_name" label="服务单状态" width="200"></el-table-column>
          <el-table-column prop="create_name" label="提交人" width="200"></el-table-column>
          <el-table-column prop="feedback" label="备注" width="200"></el-table-column>
        </el-table>
      </div>
      <div v-if="selectedRows[0].employeeDetail" style="line-height: 3">
        <el-row>
          <el-col :span="6">
            <h3>员工信息</h3>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            姓名：{{selectedRows[0].employeeDetail.name}}
          </el-col>
          <el-col :span="6">
            证件号：{{selectedRows[0].employeeDetail.id_card}}
          </el-col>
          <el-col :span="4">
            性别：{{selectedRows[0].employeeDetail.sex | sex}}
          </el-col>
          <el-col :span="4">
            民族：{{selectedRows[0].employeeDetail.nation}}
          </el-col>
          <el-col :span="4">
            年龄：{{ selectedRows[0].employeeDetail.birthday }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            部门：{{selectedRows[0].employeeDetail.dept_id}}
          </el-col>
          <el-col :span="6">
            职位：{{selectedRows[0].employeeDetail.position}}
          </el-col>
          <el-col :span="4">
            入职时间：{{selectedRows[0].employeeDetail.entry_date}}
          </el-col>
          <el-col :span="4">
            手机号：{{selectedRows[0].employeeDetail.phone}}
          </el-col>
          <el-col :span="4">
            户口性质：{{selectedRows[0].employeeDetail.hold_nature}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            户口所在地：{{selectedRows[0].employeeDetail.addr}}
          </el-col>
          <el-col :span="6">
            社保基数：{{selectedRows[0].employeeDetail.s_base | fm}}
          </el-col>
          <el-col :span="4">
            参保地区：{{ selectedRows[0].employeeDetail.insured_area_s }}
          </el-col>
          <el-col :span="4">
            公积金基数：{{ selectedRows[0].employeeDetail.f_base | fm }}
          </el-col>
          <el-col :span="4">
            缴纳地区：{{ selectedRows[0].employeeDetail.insured_area_f }}
          </el-col>
        </el-row>
      </div>
    </cx-dialog>

    <cx-query-condition :loading="loading" @query="query"
                        @reset='resetQueryCondition'>
      <el-row>
        <el-col :span="6">
          <el-form-item label="服务单号/姓名/身份证号/手机号">
            <cx-input v-model="queryCondition.keyword"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="服务单状态">
            <cx-select :options="statusList" v-model="queryCondition.status" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="服务类别">
            <cx-select :options="typeList" v-model="queryCondition.type" />
          </el-form-item>
        </el-col>
      </el-row>
    </cx-query-condition>

    <cx-btn-group>
      <el-button type="success" icon="el-icon-refresh" size='mini' :loading="loading"
                     @click='query'>刷新</el-button>
      <el-button type="primary" icon="el-icon-info" size='mini'
                 @click='detail'>详情</el-button>
    </cx-btn-group>

    <el-table v-loading="loading" :data="data"
              border
              highlight-page-row
              size='mini'
              style="width:100%;"
              @selection-change='handleSelectionChange'>
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="id" label="服务单号" width="150" fixed></el-table-column>
      <el-table-column prop="type_name" label="服务类型" width="150" fixed></el-table-column>
      <el-table-column prop="emp_name" label="服务对象" width="150" fixed></el-table-column>
      <el-table-column prop="status_name" label="办理流程状态" width="150" fixed></el-table-column>
      <!-- <el-table-column prop="insured_area" label="参保地" width="150"></el-table-column> -->
      <el-table-column prop="effective_time" label="拟生效时间" width="150"></el-table-column>
      <!-- <el-table-column prop="evaluate" label="反馈信息" width="200"></el-table-column> -->
    </el-table>
    <cx-pagination :pageData="queryCondition"
                   @sizeChange='query'
                   @pageChange='query' />

  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        formLoading: false,
        data: [],
        selectedRows: [],
        
        showForm: false,
        statusList: [],         // 服务单状态 52
        typeList: [],           // 服务类型 53

        form: {
          emp_name: ''
        },
        formData: [],

        queryCondition: {
          total: this.CONST.PAGINATION.TOTAL,
          page: this.CONST.PAGINATION.PAGE,
          rows: this.CONST.PAGINATION.ROWS,
          sort: 'id',
          order: 'desc',

          keyword: '',
          status: null,
          type: null,
        },
        queryConditionOfHistory: {
          page: 1,
          rows: this.CONST.PAGINATION.MAX_ROWS,
          sort: 'id',
          order: 'asc',

          bill_id: null,
        },
        title: '',
      }
    },
    mounted() {
      this.Util.fillDictList([52, 53], [this.statusList, this.typeList]);
      this.query();
    },
    methods: {
      handleSelectionChange(rows) {
        this.selectedRows = rows;
      },
      query() {
        this.loading = true;
        this.showForm = false;
        this.post('/bill/list', this.queryCondition).then(resp => {
          this.loading = false;
          if(resp) {
            if(resp.data['success']) {
              let data = resp.data['rows'] || [];
              data.forEach(row => {
                row.employeeDetail = {};
              });
              this.data = data;
              this.queryCondition.total = resp.data['total'];
            }
          }
        })
      },
      queryClientEmployeeDetail() {
        if(this.selectedRows[0].emp_id) {
          this.post('/client-employee/list', {
            id: this.selectedRows[0].emp_id
          }).then(resp => {
            if(resp) {
              if(resp.data['success']) {
                let rows = resp.data['rows'] || [];
                if(rows && rows.length > 0) {
                  this.selectedRows[0].employeeDetail = rows[0];
                }
              }
            }
          })
        }
      },
      resetQueryCondition() {
        this.Util.reset(this.queryCondition);
        this.queryCondition.type = null;
        this.queryCondition.status = null;
      },
      queryHistoryList() {
        this.formLoading = true;
        this.queryConditionOfHistory.bill_id = this.selectedRows[0].id;
        this.post('/bill/history-list', this.queryConditionOfHistory).then(resp => {
          this.formLoading = false;
          if(resp) {
            if(resp.data['success']) {
              let rows = resp.data['rows'] || [];
              rows.unshift({
                create_time: this.selectedRows[0].create_time,
                status_name: this.selectedRows[0].status_name,
                create_name: this.selectedRows[0].create_name,
                feedback: this.selectedRows[0].feedback,
              });
              this.formData = rows;
              this.queryConditionOfHistory.total = resp.data['total'];
            }
          }
        })
      },
      detail() {
        if (this.selectedRows.length !== 1) {
          this.error(this.CONST.TIP.SELECT_ONE_FIRST);
        } else {
          this.Util.reset(this.form);
          this.title = '服务单详情';
          this.queryHistoryList();
          this.queryClientEmployeeDetail();
          this.showForm = true;
        }
      },
    },
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/web/insurance/progress/list.vue